import React from "react";
import { PanelAddSubCategoryType } from "../../../UI/AdSubCategoryTypes/Add/PanelAddSubCategoryType";

const AddAdSubCategoryType = () => {
  return (
    <div>
      <PanelAddSubCategoryType />
    </div>
  );
};

export default AddAdSubCategoryType;
